import { cx } from "../../utils/cx";

export default function Spinner({ className }) {
  return (
    <svg className={cx("h-5 w-5 animate-spin", className)} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  );
}

// Centred spinner for a section or page that is loading
export function Loading({ label = "Loading…", className }) {
  return (
    <div className={cx("flex flex-col items-center justify-center gap-3 py-16 text-slate-500", className)}>
      <Spinner className="h-6 w-6 text-brand" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
